import React, {Component} from 'react'
import {Input} from "antd"
import 'antd/lib/input/style/index.css'
import PropTypes from 'prop-types'

class FilterMarker extends Component {
    _handleChange = (e) => {
        const {name, value} = e.target
        const {onChangeFilters} = this.props
        const filters = Object.assign({}, this.props.filters)

        if (typeof onChangeFilters === 'function') {
            onChangeFilters({
                ...filters,
                [name]: value
            })
        }
    }

    render() {
        const {filters} = this.props
        const {marker} = filters

        return (
            <div className="FilterOrderNumber mb-3 mr-3">
                <label className='font-weight-bold d-block'>Người đánh dấu</label>
                <Input name="checker" value={marker} onChange={this._handleChange} placeholder='Tìm kiếm người đánh dấu' style={{width: 350}}/>
            </div>
        )
    }
}

FilterMarker.propTypes = {
    filters: PropTypes.object.isRequired,
    onChangeFilters: PropTypes.func.isRequired
}

export default FilterMarker